<template>
    <div class="module">
        <p class="module-title module-title-1">邀请助力得现金红包</p>
        <div class="module-tip g-flex">
            <p>每邀请1个好友可获得一个红包</p>
            <p class="module-tip-record" @click="jumpToRecord">助力记录</p>
            <div class="g-h5-ui-iconfont arrow-icon" @click="jumpToRecord">&#xe660;</div>
        </div>

        <div class="module-btn" @click="toInvite">
            <div class="module-btn-icon"></div>
            <p class="module-btn-text">去邀请</p>
        </div>
        <div class="module-guide"></div>
    </div>
</template>
<script lang="ts" setup>
import { ref, getCurrentInstance } from 'vue';
import { openWebview, openLogin } from '@q-front-npm/jsbridge';
import { useStore } from '../../store';
import { useStoreCommon } from '@qm-activity/common/store/common';
import { jsbSupportMap } from '@q-front-npm/jsbridge';
const instance = getCurrentInstance()!;
const store = useStore();
const storeCommon = useStoreCommon();
const jumpToRecord = () => {
    openWebview(`https://api-marathon.wtzw.com/h5/activity/freereaderMarathon2026/sidePanel/details?full_screen=3`);
};

const toInvite = () => {
    if (!storeCommon.userInfo.isLogin) {
        openLogin();
        return;
    }
    if (jsbSupportMap.app.share) {
        store.setPopManage('share', true);
    } else {
        instance.proxy.$toast('请更新至最新版本以参与活动');
    }
};
</script>
<style lang="scss" scoped>
.arrow-icon {
    transform: rotate(180deg);
    display: block;
    margin-left: -4px;
}
.module-tip {
    margin-left: 8px;
    margin-top: 4px;
    font-size: 22px;
    color: #854242;
    line-height: 32px;
    &-record {
        margin-left: 16px;
    }
}
.module-btn {
    position: absolute;
    right: 24px;
    top: 50px;

    width: 116px;
    height: 52px;
    background: linear-gradient(270deg, #ff3904 0%, #ff6a4a 100%);
    border-radius: 26px;
    &-icon {
        position: absolute;
        top: -32px;
        left: 0;
        right: 0;
        margin: auto;
        width: 80px;
        height: 46px;
        background: url('@divide/assets/images/divide_pop_headbg@3x.png') no-repeat center center;
        background-size: 100% 100%;
    }
    &-text {
        font-weight: bold;
        font-size: 24px;
        color: #ffffff;
        line-height: 52px;
        text-align: center;
    }
}
.module-guide {
    margin-top: 24px;
    background: url('@divide/assets/images/divide_fangfa@3x.png') no-repeat center center;
    background-size: auto 100%;
    width: 100%;
    height: 190px;
}
</style>
